import API from './api';
import { exportResults } from '../utils/index';
import { HTTP } from '../config/http-common';

export default class NotificationApi extends API {
    pushNoti = async (id) => exportResults(await HTTP.post(`${this.ROUTE}/send_fcm_to_group/${id}`));
}
